// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.
import { EditServerModal } from '@/components/modals/edit-server-modal.tsx';
import { InviteModal } from '@/components/modals/invite-modal.tsx';
import { CreateServerModal } from '@/components/modals/create-server-modal.tsx';
import { MembersModal } from '@/components/modals/members-modal.tsx';
import { CreateChannelModal } from '@/components/modals/create-channel-modal.tsx';
import { LeaveServerModal } from '@/components/modals/leave-server-modal.tsx';
import { DeleteServerModal } from '@/components/modals/delete-server-modal.tsx';
import { DeleteChannelModal } from '@/components/modals/delete-channel-modal.tsx';
import { EditChannelModal } from '@/components/modals/edit-channel-modal.tsx';
import { MessageFileModal } from '@/components/modals/message-file-modal.tsx';
import { DeleteMessageModal } from '@/components/modals/delete-message-modal.tsx';
import { DeleteUserModal } from '@/components/modals/delete-user-modal.tsx';
import { IncomingCallModal } from '@/components/modals/incoming-call-modal.tsx';
import { useModal } from '@/stores/use-modal-store.ts';
import { CreateServerEventModal } from '@/components/modals/create-server-event-modal.tsx';
import { EditServerEventModal } from '@/components/modals/edit-server-event-modal.tsx';

export const ModalRenderer = () => {
  const { type, isOpen, data, onClose } = useModal();

  if (!isOpen || !type) return null;

  const modalProps = { isOpen: true, onClose, data };

  switch (type) {
    case 'invite':
      return <InviteModal {...modalProps} />;
    case 'editServer':
      return <EditServerModal {...modalProps} />;
    case 'createServer':
      return <CreateServerModal {...modalProps} />;
    case 'deleteServer':
      return <DeleteServerModal {...modalProps} />;
    case 'leaveServer':
      return <LeaveServerModal {...modalProps} />;
    case 'members':
      return <MembersModal {...modalProps} />;
    case 'createChannel':
      return <CreateChannelModal {...modalProps} />;
    case 'deleteChannel':
      return <DeleteChannelModal {...modalProps} />;
    case 'editChannel':
      return <EditChannelModal {...modalProps} />;
    case 'messageFile':
      return <MessageFileModal {...modalProps} />;
    case 'deleteMessage':
      return <DeleteMessageModal {...modalProps} />;
    case 'deleteUser':
      return <DeleteUserModal {...modalProps} />;
    case 'incomingCall':
      return <IncomingCallModal {...modalProps} />;
    case 'createServerEvent':
      return <CreateServerEventModal {...modalProps} />;
    case 'editServerEvent':
      return <EditServerEventModal {...modalProps} />;
    default:
      return null;
  }
};
